var Acre = "阿克里州";
var Alagoas = "阿拉戈斯州";
var Amazonas = "亚马逊州";
var Bahia = "巴伊亚州";
var Pernambuco = "伯南布哥州";
var Roraima = "罗赖马州";
var Sergipe = "塞尔希培州";
var Tocantins = "托坎廷斯州";
var PTStates = {
	Acre: Acre,
	Alagoas: Alagoas,
	"Amapá": "阿马帕州",
	Amazonas: Amazonas,
	Bahia: Bahia,
	"Ceará": "塞阿拉州",
	"Federal District": "联邦区",
	"Espírito Santo": "圣埃斯皮里图州",
	"Goiás": "戈亚斯州",
	"Maranhão": "马拉尼昂州",
	"Mato Grosso": "马托格罗索州",
	"Mato Grosso do Sul": "南马托格罗索州",
	"Minas Gerais": "米纳斯吉拉斯州",
	"Pará": "帕拉州",
	"Paraíba": "帕拉伊巴州",
	"Paraná": "巴拉那州",
	Pernambuco: Pernambuco,
	"Piauí": "皮奥伊州",
	"Rio de Janeiro": "里约热内卢州",
	"Rio Grande do Norte": "北里奥格兰德州",
	"Rio Grande do Sul": "南里奥格兰德州",
	"Rondônia": "朗多尼亚州",
	Roraima: Roraima,
	"Santa Catarina": "圣卡塔琳娜州",
	"São Paulo": "圣保罗州",
	Sergipe: Sergipe,
	Tocantins: Tocantins
};

export { Acre, Alagoas, Amazonas, Bahia, Pernambuco, Roraima, Sergipe, Tocantins, PTStates as default };
